export enum BlockAccessType {
  ACTIVITY = 'activity',
  SIGNIN = 'signin',
}

export interface BlockAccessModalParam {
  blockAccessType: BlockAccessType
  onClickConfirm?: () => void
}
